import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';
import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { DataStore } from 'common/module/data/store';
import { preactMarkup } from 'common/typings/preact-markup';

import { MessageComponent } from './component';
import { MessageEventEnum } from './event.enum';
import { MessagePropsInterface } from './props.interface';

export class MessageViewStore extends DataStore<MessagePropsInterface> {
  /**
   * Default auto hide duration in seconds
   */
  public static readonly AUTO_HIDE_DEFAULT_DURATION_WITH_ACTIONS: number = 8;

  /**
   * Constructor
   */
  constructor(eventEmitter: EventEmitterInterface, private preactMarkupHelper: preactMarkup) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(): void {
    this.state = {};

    this.preactMarkupHelper(domQuerySelector(document, '[data-qs="snackbar"]'), { MessageComponent });
  }

  /**
   * Display a snackbar message
   */
  public alert(snackbar: Pick<MessagePropsInterface, 'message' | 'autoHideDuration' | 'action' | 'onClose'>): void {
    const autoHideDuration =
      typeof snackbar.autoHideDuration === 'undefined' && snackbar.action
        ? MessageViewStore.AUTO_HIDE_DEFAULT_DURATION_WITH_ACTIONS
        : snackbar.autoHideDuration;

    this.setState({
      ...snackbar,
      id: Math.random().toString(16).replace('0.', ''),
      visible: true,
      autoHideDuration,
      onOpen: (options) => this.getEventEmitter().emit(MessageEventEnum.open, options),
      onClose: () => this.getEventEmitter().emit(MessageEventEnum.close),
    });
  }

  /**
   * update message visibility
   */
  public updateVisibility(isVisible: boolean): void {
    this.setState({
      ...this.state,
      visible: isVisible,
    });
  }
}
